var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheckBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1835 4.93706C11.3254 4.93709 11.4517 4.9903 11.5634 5.09917C11.6749 5.21085 11.7303 5.33783 11.7303 5.481C11.7303 5.62431 11.675 5.75204 11.5634 5.86382L7.05066 10.3804C6.94192 10.4891 6.81434 10.5425 6.66687 10.5425C6.51921 10.5425 6.39094 10.4893 6.2821 10.3804L4.4325 8.52983H4.43152C4.32304 8.41832 4.27039 8.29112 4.27039 8.14799C4.27039 8.04044 4.30053 7.94176 4.36316 7.8521L4.4364 7.76616C4.54801 7.65722 4.67491 7.60318 4.81824 7.60307C4.96174 7.60307 5.08933 7.65711 5.20105 7.76616L6.64929 9.21831L6.66687 9.23589L10.8036 5.09917L10.8026 5.09819C10.9143 4.98937 11.0415 4.93706 11.1835 4.93706Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckBlue);
export default __webpack_public_path__ + "static/media/circle-check-blue.11b12215bea43bf6ec18d8006d9e1e88.svg";
export { ForwardRef as ReactComponent };